import template from './exploreShow.jade';
import Rx from 'rx';
import * as $ from 'jquery';

class ExploreShowController {
  constructor($stateParams, $state, notify, $http, featureFlagsHelper, currentGame, currentExploreGroup, currentExploreGroupForCharts, exploreBenchmarkSnapshotSubject, exploreFilteredSnapshotDataSubject, BundlesResource, UserExplorerResource, UserExplorerUserGroupsResource, userExploreConstants) {
    this.$http = $http;
    this.$state = $state;
    this.notify = notify;
    this.BundlesResource = BundlesResource;
    this.UserExplorerResource = UserExplorerResource;
    this.UserExplorerUserGroupsResource = UserExplorerUserGroupsResource;
    this.currentGame = currentGame;
    this.currentExploreGroup = currentExploreGroup;
    this.exploreBenchmarkSnapshotSubject = exploreBenchmarkSnapshotSubject;
    this.exploreFilteredSnapshotDataSubject = exploreFilteredSnapshotDataSubject;
    this.userExploreConstants = userExploreConstants;
    this.$stateParams = $stateParams;
    this.groupId = $stateParams.groupId;
    this.visualizationMode = "snapshot";
    this.maxNameLength = 256;
    this.disposables = [];
    this.cachedBenchmarkSnapshot;

    this.getBenchmarkSnapshotData(this.$stateParams.gameId);

    this.exploreGroup = {
      name: "All Users",
      active_days: [1],
      sessions_per_day: [1],
      other_apps: [1],
      registration_date: null,
      genres: [],
      apps: [],
      is_paying: false,
      payment_amount: [1],
      transactions: [1],
      is_male: false,
      is_female: false,
      age: [1,7],
      is_ios: false,
      is_android: false,
      is_phone: false,
      is_tablet: false,
      countries: [],
      acquisition_source: []
    };

    this.initialExploreGroupSnapshot = _.clone(this.exploreGroup);

    // explore-show is responsible to fetch and persist data.
    // here we call "POST /api/v1/user-explorer/{game_id}/snapshot"
    // every time the filters change
    // then, we notify other components like ExploreDataHeaderNg1Controller and ExploreWidgetTabsNg1Controller via exploreFilteredSnapshotDataSubject
    this.disposables.push(this.currentExploreGroup.subscribe((group) => {
      if(group != null) {
        this.exploreGroup = group;
        currentExploreGroupForCharts.onNext(this.serializeGroupDefinition(group));
        if(!_.isEqual(this.initialExploreGroupSnapshot, group)) {
          this.UserExplorerResource.one(this.$stateParams.gameId).customPOST(this.serializeGroupDefinition(group), 'snapshot').then((res) => {
            this.exploreFilteredSnapshotDataSubject.onNext(res);
          });
        } else {
          // If no filter is set, then onNext on the benchmark snapshot data.
          if(this.cachedBenchmarkSnapshot) {
            //isNoGroupLoadedAndPristineFilters_fresh we need because isNoGroupLoadedAndPristineFilters we pass as an input to exploreWidgetTabsNg1
            //isn't updated yet when we trigger exploreBenchmarkSnapshotSubject.onNext
            this.cachedBenchmarkSnapshot.isNoGroupLoadedAndPristineFilters_fresh = this.isNoGroupLoadedAndPristineFilters;
            this.exploreBenchmarkSnapshotSubject.onNext(this.cachedBenchmarkSnapshot);
          }
        }
      }
    }));

    this.disposeObservable = (d) => { d.dispose() };

    this.$onDestroy = () => {
      _.forEach(this.disposables, (d) => { this.disposeObservable(d) });
    };

    if(this.groupId) {
      this.UserExplorerUserGroupsResource.one(parseInt(this.groupId,10)).get().then((res) => {
        this.exploreGroup = _.clone(this.deserializeExploreGroup(res.plain()));
        this.initialExploreGroupSnapshot = _.clone(this.exploreGroup);
        // TODO check if we really need to notify other components about a new explore group
        // data-header needs it for the name and the id of the group
        // maybe we should create a different subject for the name
        this.currentExploreGroup.onNext(this.exploreGroup);
        // TODO when explore-group-GET API is ready, call "POST /api/v1/user-explorer/{game_id}/snapshot"
        // with the group definition (filter) returned by it and then call -> this.exploreFilteredSnapshotDataSubject.onNext(res);
      });
    } else {
      this.currentExploreGroup.onNext(this.exploreGroup);
    }

    this.currentGame.subscribe((game) => {
      this.game = game;
      this.enrichGameData(this.game);
    });
  }

  deserializeExploreGroup(serializedUserGroup) {
    let userGroupDefinition = JSON.parse(serializedUserGroup.definition);
    return {
      name: serializedUserGroup.name,
      active_days: [this.getSliderValueFromBucketValue(userGroupDefinition.active_days, 'activeDaysSliderTickToValue', 1)],
      sessions_per_day: [this.getSliderValueFromBucketValue(userGroupDefinition.sessions_per_day, 'sessionsSliderTickToValue', 1)],
      other_apps: [this.getSliderValueFromBucketValue(userGroupDefinition.other_apps, 'otherAppsSliderTickToValue', 1)],
      registration_date: moment.utc(userGroupDefinition.registration_date).toDate(),
      genres: userGroupDefinition.genres,
      apps: userGroupDefinition.apps,
      is_paying: userGroupDefinition.is_paying,
      payment_amount: [this.getSliderValueFromBucketValue(userGroupDefinition.payment_amount, 'paymentAmountSliderTickToValue', 1)],
      transactions: [this.getSliderValueFromBucketValue(userGroupDefinition.transactions, 'transactionsSliderTickToValue', 1)],
      is_male: userGroupDefinition.is_male,
      is_female: userGroupDefinition.is_female,
      age: [
        userGroupDefinition.age ? this.getSliderValueFromBucketValue(userGroupDefinition.age.from, 'ageSliderTickToRange', 1) : 1,
        userGroupDefinition.age ? this.getSliderValueFromBucketValue(userGroupDefinition.age.to, 'ageSliderTickToRange', 7): 7
      ],
      is_ios: userGroupDefinition.is_ios,
      is_android: userGroupDefinition.is_android,
      is_phone: userGroupDefinition.is_phone,
      is_tablet: userGroupDefinition.is_tablet,
      countries: userGroupDefinition.countries,
      acquisition_source: userGroupDefinition.acquisition_source
    };
  }

  serializeGroup() {
    let serializedGroup = {
        name: this.exploreGroup.name,
        game_id: parseInt(this.$stateParams.gameId),
        definition: JSON.stringify(this.serializeGroupDefinition(this.exploreGroup))
    };
    if(this.groupId) {
      serializedGroup.id = parseInt(this.groupId);
    }
    return serializedGroup;
  }


  serializeGroupDefinition(exploreGroup) {
    return _.omitBy({
      active_days: this.getBucketValueFromSliderValue(exploreGroup.active_days[0], 'activeDaysSliderTickToValue'),
      sessions_per_day: this.getBucketValueFromSliderValue(exploreGroup.sessions_per_day[0], 'sessionsSliderTickToValue'),
      other_apps: this.getBucketValueFromSliderValue(exploreGroup.other_apps[0], 'otherAppsSliderTickToValue'),
      registration_date: exploreGroup.registration_date,
      genres: exploreGroup.genres,
      apps: exploreGroup.apps,
      is_paying: exploreGroup.is_paying,
      payment_amount: this.getBucketValueFromSliderValue(exploreGroup.payment_amount[0], 'paymentAmountSliderTickToValue'),
      transactions: this.getBucketValueFromSliderValue(exploreGroup.transactions[0], 'transactionsSliderTickToValue'),
      is_male: exploreGroup.is_male,
      is_female: exploreGroup.is_female,
      age: this.serializeAge(exploreGroup.age),
      is_ios: exploreGroup.is_ios,
      is_android: exploreGroup.is_android,
      is_phone: exploreGroup.is_phone,
      is_tablet: exploreGroup.is_tablet,
      countries: exploreGroup.countries,
      acquisition_source: exploreGroup.acquisition_source
    }, _.isNull);
  }

  getBucketValueFromSliderValue(sliderTickValue, tickToValueConfig) {
    return this.userExploreConstants[tickToValueConfig][sliderTickValue+'.00'].to
  }

  getSliderValueFromBucketValue(bucketValue, tickToValueConfig, defaultTick) {
    let tempTick = defaultTick;
    _.forEach(this.userExploreConstants[tickToValueConfig], (tickFromToValues, tick) => {
      if(bucketValue >= tickFromToValues.from && bucketValue <= tickFromToValues.to) {
        tempTick = tick;
      }
    });
    return parseInt(tempTick, 10);
  }

  serializeAge(ageSliderTickValue) {
    if(ageSliderTickValue[0] == 1 && ageSliderTickValue[1] == 7) {
      return null;
    } else {
      return {
        from: this.userExploreConstants.ageSliderTickToRange[ageSliderTickValue[0]+'.00'].from,
        to: this.userExploreConstants.ageSliderTickToRange[ageSliderTickValue[1]+'.00'].to
      };
    }
  }

  getBenchmarkSnapshotData(gameId) {
    this.UserExplorerResource.one(gameId).customGET('snapshot').then((res) => {
      this.cachedBenchmarkSnapshot = res;
      //isNoGroupLoadedAndPristineFilters_fresh we need because isNoGroupLoadedAndPristineFilters we pass as an input to exploreWidgetTabsNg1
      //isn't updated yet when we trigger exploreBenchmarkSnapshotSubject.onNext
      this.cachedBenchmarkSnapshot.isNoGroupLoadedAndPristineFilters_fresh = this.isNoGroupLoadedAndPristineFilters;
      this.exploreBenchmarkSnapshotSubject.onNext(this.cachedBenchmarkSnapshot);
    });
  }

  get isNoGroupLoadedAndPristineFilters() {
    return !this.groupId && !this.areFiltersModified;
  }

  get areFiltersModified() {
    return !_.isEqual(this.exploreGroup, this.initialExploreGroupSnapshot);
  }

  enrichGameData(game) {
    let bundle_id = game.ios_bundle_id || game.android_bundle_id;
    this.BundlesResource.one(bundle_id).get()
    .then((bundleInfo) => {
      game.icon = game.url || bundleInfo.icon;
      let ratingPercentNumber = bundleInfo.rating ? bundleInfo.rating / 5 * 100 : 0;
      game.ratingPercent = ratingPercentNumber+"%";
    });

    game.getGameDeveloper()
    .then((gameDeveloper) => {
      game.gameDeveloper = gameDeveloper.company_name;
    });
  }

  uniqueUserGroupNameCheck(serializedGroup) {
    if(this.initialExploreGroupSnapshot.name == serializedGroup.name) {
      serializedGroup.name += ' (1)';
    }
    return serializedGroup
  }

  saveNewUserGroup() {
    let serializedGroup = this.serializeGroup();
    serializedGroup = this.uniqueUserGroupNameCheck(serializedGroup);
    this.validationCheck(serializedGroup) && this.UserExplorerUserGroupsResource.post(serializedGroup)
      .then((res) => {
        this.notify.created('group', res.name);
        this.$state.go('app.explore.show.existing', {groupId: res.id});
      });
  }

  saveUserGroupAs() {
    let serializedGroup = this.serializeGroup();
    delete serializedGroup.id;
    serializedGroup = this.uniqueUserGroupNameCheck(serializedGroup);
    this.validationCheck(serializedGroup) && this.UserExplorerUserGroupsResource.post(serializedGroup)
      .then((res) => {
        this.notify.created('group', res.name);
        this.$state.go('app.explore.show.existing', {groupId: res.id});
      });
  }

  updateUserGroup() {
    let serializedGroup = this.serializeGroup();
    this.validationCheck(serializedGroup) && this.UserExplorerUserGroupsResource.one(parseInt(this.groupId,10)).customPUT(serializedGroup)
      .then((res) => {
        this.notify.updated('group', res.name);
        this.$state.go('app.explore.show.existing', {groupId: res.id});
      });
  }

  clearFilters() {
    this.exploreGroup = _.clone(this.initialExploreGroupSnapshot);
    this.currentExploreGroup.onNext(this.exploreGroup);
  }

  validationCheck(serializedGroup) {
    if(serializedGroup.name && serializedGroup.name.length < this.maxNameLength) {
      return true;
    } else {
      this.notify.warning('fieldTooLong', { fieldName: 'User Group Name' });
      return false;
    }
  }
}

let ExploreShowComponent = {
  template: () => { return template },
  controller: ExploreShowController,
  controllerAs: 'vm',
  bindings: {}
};

export default angular.module('app.components.explore.show', [])
  .component('exploreShow', ExploreShowComponent);


/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreShow.js
 **/